import React from "react";
import { Line } from "react-chartjs-2";

const ChartLineProgresLiterasi = ({dataProgres, ranges, height}) => {
    let listProgres = dataProgres
    let range = ranges
    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
        },
    };
    let lstNewDataSet= []
    for (let i in listProgres) {
        const item = listProgres[i]
        const dataSet = new Object()
        dataSet.label = item.kategori
        dataSet.borderColor = item.color
        dataSet.pointBorderColor = item.color
        dataSet.pointBackgroundColor = item.color
        dataSet.pointHoverBackgroundColor = item.color
        dataSet.pointHoverBorderColor = item.color
        dataSet.pointBorderWidth = 10
        dataSet.pointHoverRadius = 10
        dataSet.pointHoverBorderWidth = 1
        dataSet.pointRadius = 3
        dataSet.fill = false
        dataSet.borderWidth = 4
        dataSet.data = item.skor
        lstNewDataSet.push(dataSet)
    }
    const data = {
        labels: range,
        datasets: lstNewDataSet
    };

    return (
        <div>
            <Line data={data} options={options} width={300} height={height} />
        </div>
    );
};

export default ChartLineProgresLiterasi;
